import { Button } from '@good/ui/core';
import { FileDownload } from '@good/icons';
import { IServiceAgreement } from 'interfaces/customer-interfaces';
import React from 'react';
import { reactTrpc } from 'utilities/react-trpc';
interface DownloadPdfButtonProps {
  serviceAgreement: IServiceAgreement;
}

export const DownloadPdfButton = ({ serviceAgreement }: DownloadPdfButtonProps) => {
  const {
    data: history,
    isLoading,
    isError,
  } = reactTrpc.customers.userServiceAgreementHistories.fetchLatestHistory.useQuery({
    userServiceAgreementId: serviceAgreement.userServiceAgreementId,
  });
  const signedUrl = history?.signedUrl;

  const onDownloadPdf = () => {
    if (isError || !signedUrl) {
      window.open(
        `/pdf?type=service-agreement&agreement=${serviceAgreement.userServiceAgreementId}`,
        '_blank',
        'noopener,noreferrer',
      );
      return;
    }

    window.open(signedUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <Button leftSection={<FileDownload />} loading={isLoading} onClick={onDownloadPdf} variant='default'>
      Download {signedUrl ? 'signed' : 'unsigned'} PDF
    </Button>
  );
};
